import { InjectionToken } from '@angular/core';
import { SearchService } from '../../../../shared/services/search.service';

export const MaintenanceTaskSearchService = new InjectionToken<SearchService>('MaintenanceTaskSearchService');
